import { render } from "./About.vue?vue&type=template&id=6a6eb6b3&scoped=true&lang=pug"
const script = {}

import "./About.vue?vue&type=style&index=0&id=6a6eb6b3&lang=less&scoped=true"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6eb6b3"]])

export default __exports__